<template>
    <el-drawer
        title="批量结款"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content">
            <el-upload
                drag
                action
                :http-request="uploadExcel"
                :auto-upload="false"
                ref="upload"
                accept=".xls, .xlsx"
                :show-file-list="true"
                :before-upload="beforeUpload"
                :file-list="fileList"
                :on-change="onChange"
                :on-remove="onRemove"
                :disabled="uploadLoading">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击选择文件</em></div>
                <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且最多不超过2W行</div>
            </el-upload>
            <div class="color-info">
                导入文件示例如下:
                <el-button 
                    v-if="$utils.have('/activityFinanceSettle/downTemplate')" 
                    type="text" 
                    icon="el-icon-download" 
                    @click="download">
                    点击下载模板
                </el-button>
            </div>
            <div class="temp-table">
                <el-table
                    :data="tempModel"
                    style="width: 100%"
                    size="small"
                    border
                >
                    <el-table-column prop="id" label="结款演出ID" min-width="90"></el-table-column>
                    <el-table-column prop="cardId" label="结款方卡号" min-width="160"></el-table-column>
                    <el-table-column prop="name" label="结款方账户名" min-width="170"></el-table-column>
                    <el-table-column prop="code" label="打款流水号" min-width="140"></el-table-column>
                </el-table>
            </div>
            <div class="drawer-footer">
                <el-button @click="close">取消</el-button>
                <el-button type="primary" @click="onSubmit" :loading="btnLoading" :disabled="canSubmit">提交</el-button>
            </div>
            <ErrorMsgDrawer ref="errorMsgDrawer" :maxlength="100"></ErrorMsgDrawer>    
        </div>
    </el-drawer>
</template>

<script>
import {downloadFileTmp,uploadFileTmp} from '@/assets/js/commonApi.js';
import ErrorMsgDrawer from '@/components/ErrorMsgDrawer';
export default {
    components:{ErrorMsgDrawer},
    data(){
        return{
            drawerShow:false,
            btnLoading:false,
            downLoading:false,
            uploadLoading:false,
            tempModel:[{
                id:'123',
                cardId:'622588340123115568',
                name:'张掖文化传媒有限责任公司',
                code:'000000000000001',
            },{
                id:'456',
                cardId:'622588340123115568',
                name:'张掖文化传媒有限责任公司',
                code:'Ems033000000008'
            }],
            canSubmit:true,
            fileList:[],
        }
    },
    methods:{
        show() {
            this.drawerShow = true;
        },
        close(){
            this.fileList = [];
            this.$refs.upload.clearFiles();
            this.drawerShow = false;
        },
        //下载模板
        async download(){
            let filePath;
            this.downLoading = true;
            const res = await this.$request({
                url:'/activityFinanceSettle/downTemplate',
                method: 'post',
            })
                .catch(err => {
                    this.$message({message: err.message, type: 'error'});
                })
            const{state,msg,result:{url}} = res.data;
            if(state == 1 &&  url){
                filePath = url;
            }else{
                this.downLoading = false;
                return this.$message.error(msg || '下载失败');
            }   

            await downloadFileTmp(filePath,'批量结款模板.'+this.$utils.getFileType(filePath));
            this.downLoading = false;
        },
        onSubmit(){
            this.$refs.upload.submit();
        },
        async uploadExcel(req){
            this.btnLoading = true;
            this.uploadLoading = true;
            const formData = new FormData();
            formData.append('file', req.file);

            let filePath;
            const res = await uploadFileTmp(formData).catch(err => {
                this.$message({message: err.message, type: 'error'});
            }).finally(() => {
                this.uploadLoading = false;
            });
            const{state,msg,result} = res.data;
            if (state == 1 && result) {
                filePath = result.url;
            }else{
                this.$message.error(msg || '上传失败');
            }

            this.$request({
                url:'/agent/settle/batchReceivables',
                method: 'post',
                params:{path:filePath}
            })
                .then(res => {
                    const{state,msg,result} = res.data;
                    if (state == 1) {
                        if(result && result.importErrorDetailVOList){
                            // this.errMsgShow = true;
                            //this.errMsgList = result;
                            this.$refs.errorMsgDrawer.show(result);
                        }else{
                            this.onSuccess();
                        }
                        
                    }else{
                        this.$message.error(msg || '上传失败');
                        this.canSubmit = false;
                    }
                })
                .catch(err => {
                    this.canSubmit = false;
                    this.$message({message: err.message, type: 'error'});
                })
                .finally(() => {
                    this.btnLoading = false;
                    this.canSubmit = true;
                });
        },
        beforeUpload(file){
            const type = this.$utils.getFileType(file.name)
            const isType = type === 'xls' || type === 'xlsx';
            if (!isType) {
                this.$message.error('仅支持xls、xlsx文件格式,请重新选择上传文件!');
            }
            return isType;
        },
        onSuccess(){
            this.$emit('onUpdate');
            this.close();
        },
        onChange(file){
            if( file ){
                this.fileList = [{...file}]
                this.canSubmit = false;
            }else{
                this.canSubmit = true;
            }
        },
        onRemove(){
            this.canSubmit = true;
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .el-upload-dragger, 
::v-deep .el-upload{
    width: 100%;
}
.color-info{
    margin-top: 20px;
}
.el-table{
    margin-bottom: 10px;
}
.from-tip{
    max-width: 420px;
    font-size: 12px;
    b{
        color: $--color-theme;
    }
}
</style>